import { useState, memo } from "react";
// import user from "@/store/user";
import cln from "classnames";
import { useTranslation } from "react-i18next";
// import userImg from "@/assets/images/girl_head.png";
import { editPassword, initPassword, logout } from "logic/src/services/auth";
import { ResCode } from "logic/src/constants/request";
import useMessage from "logic/src/utils/useMessage";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import Feedback from "../Feedback";
import UserSetting from "../UserSetting";
import Password from "../Password";
import i18next from "logic/src/i18n";
import { SenseChat } from "logic/src/utils/error";
import { desensitize } from "logic/src/utils";
import authVM from "logic/src/businesses/auth/vm";
import userImg from "@/assets/images/userCenter.svg";
import { ReactComponent as UnLockIcon } from "@/components/icons/Unlock.svg";
import { ReactComponent as SettingIcon } from "@/components/icons/Setting.svg";
import { ReactComponent as MailIcon } from "@/components/icons/Mail.svg";
import { ReactComponent as LogoutIcon } from "@/components/icons/Logout.svg";
import styles from "./index.module.scss";

// const { confirm } = Modal;

const UserCenter = ({
  onMenuClick,
  resetInit,
}: {
  onMenuClick: () => void;
  resetInit: () => void;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const showUserInfo = authVM.user.userInfo?.mobile
    ? desensitize(authVM.user.userInfo?.mobile)
    : authVM.user.userInfo?.name;

  const [showSetting, setShowSetting] = useState(false);
  const [showUserSetting, setShowUserSetting] = useState(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showUserFeedback, setShowUserFeedback] = useState<boolean>(false);
  const messageApi = useMessage();
  const [modal, contextHolder] = Modal.useModal();

  // 展示意见反馈
  const handleShowUserFeedback = () => {
    onMenuClick();
    setShowUserFeedback(true);
    setShowSetting(false);
  };

  // 其他设置
  const handleShowUserSetting = () => {
    onMenuClick();
    setShowSetting(false);
    setShowUserSetting(true);
  };

  const handleOpenPassword = () => {
    onMenuClick();
    setShowSetting(false);
    setShowPassword(true);
  };

  const requestLogout = async () => {
    try {
      await authVM.logout();
      await resetInit();
      messageApi.info(t("sensechat-52")); // "退出成功"
    } catch (error) {
      // messageApi.destroy(loadingId);
    }
    // navigate("/");
  };

  const handleShowLogout = () => {
    onMenuClick();
    setShowSetting(false);
    modal.confirm({
      title: t("sensechat-29"), // 确认退出登录吗?
      okText: t("sensechat-57"), // 确定
      autoFocusButton: null,
      centered: true,
      okButtonProps: { className: "sj-button", size: "small", type: "dashed" },
      cancelText: t("sensechat-21"), // 取消
      cancelButtonProps: {
        className: "sj-button",
        size: "small",
        type: "primary",
      },
      onOk() {
        requestLogout();
      },
      onCancel() {
        console.log("cancel logout");
      },
    });
  };

  const handleFinishPassword = () => {
    setShowPassword(false);
    setShowSetting(false);
  };

  return (
    <>
      <div
        // onMouseLeave={handleHideSetting}
        // onMouseEnter={handleShowSetting}
        className={styles.container}
      >
        <div className={styles.person}>
          <div className={cln(styles.settingItem, styles.settingTextActive)}>
            {showUserInfo}
          </div>
          <div className={styles.settingItem} onClick={handleOpenPassword}>
            <UnLockIcon className={styles.itemIcon} />
            {/* 设置密码 : 修改密码 */}
            {authVM.user.userInfo?.need_init_passwd
              ? t("sensechat-83")
              : t("sensechat-85")}
          </div>
          <div className={styles.settingItem} onClick={handleShowUserSetting}>
            <SettingIcon className={styles.itemIcon} />
            {/* 其他设置 */}
            {t("sensechat-28")}
          </div>
          {/* 意见反馈 */}
          <div className={styles.settingItem} onClick={handleShowUserFeedback}>
            <MailIcon className={styles.itemIcon} />

            {t("sensechat-264")}
          </div>
          <div className={styles.settingItem} onClick={handleShowLogout}>
            <LogoutIcon className={styles.itemIcon} />
            {t("sensechat-4")}
            {/* 退出登录 */}
          </div>
        </div>
      </div>
      <Feedback
        open={showUserFeedback}
        onCancel={() => setShowUserFeedback(false)}
      />
      <UserSetting
        open={showUserSetting}
        onClose={() => setShowUserSetting(false)}
        resetInit={resetInit}
      />
      <Password
        visible={showPassword}
        onClose={() => setShowPassword(false)}
        onFinish={handleFinishPassword}
      />
      {messageApi.contextHolder}
      {contextHolder}
    </>
  );
};

export default memo(UserCenter);
